import { connect } from 'react-redux';

import { 
  _closeModifyTimeEx,
  _saveModifyTimeEx,
  _updateModifyTimeEx,
  _deleteModifyTimeEx
} from '@/actions/mainAction';

import ModifyTimeEx from '@/components/main/ModifyTimeEx';

export default connect(
  state => ({
    isOpen: state.main.isOpenModifyTimeExModal,
    modifyTimeInfo: state.main.modifyTimeExInfo
  }),
  {
    _closeModifyTimeEx,
    _saveModifyTimeEx,
    _updateModifyTimeEx,
    _deleteModifyTimeEx
  }
)(ModifyTimeEx);



// WEBPACK FOOTER //
// ./src/containers/main/ModifyTimeExContainer.js